import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { SetNewValueObject } from '@vi-iot/client';
import { InputValuePipe } from '../../../../../../shared/pipes/input-value/input-value.pipe';

@Component({
  selector: 'app-vdd-text-edit',
  templateUrl: './vdd-text-edit.component.html',
  styleUrls: ['./vdd-text-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddTextEditComponent implements OnInit {
  maxLength = 15;

  @Input() matchedValue: any;
  @Input() isDescription: boolean;
  @Output() setNewValue = new EventEmitter<SetNewValueObject>();

  constructor(private inputValuePipe: InputValuePipe) {}

  ngOnInit(): void {
    const constraints = this.matchedValue.constraints;
    if (constraints?.length) {
      this.maxLength = constraints.slice(constraints.indexOf(':') + 1, constraints.indexOf(']'));
    }
  }

  valueChange(event: Event): void {
    const newValue = this.inputValuePipe.transform(event);

    this.setNewValue.emit({
      path: this.matchedValue?.path,
      newValue,
    });
  }
}
